/*
 * @Author: your name
 * @Date: 2020-12-24 15:06:04
 * @LastEditTime: 2021-03-05 14:08:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\assets\js\AdminMember\adminApplication.js
 */
import Questionnaire from "@/views/Home/common/Questionnaire.vue";
import HonorInfo from "@/views/Home/common/HonorInfo.vue";
import Contact from "@/views/Home/common/Contact.vue";
import Payment from "@/views/Home/common/Payment.vue";
import BackDialog from "@/views/Home/common/BackDialog.vue";
import FileManagement from "@/views/Home/common/FileManagement.vue";
import { time } from "@/assets/js/common";
import {
  getRecordList,
  failReason,
  findApproveHistory,
  taskManagement
} from "@/api/index";
export default {
  data() {
    return {
      userId: sessionStorage.getItem("userId"),
      tabIndex: 0, //0审批页面 其他数字详情页面
      activeName: "1",
      pendingTotal: sessionStorage.getItem("pendingTotal")
        ? sessionStorage.getItem("pendingTotal")
        : 0,
      activeIndex: 0, // 0全部 1即将超时 2已经超时
      taskValue: "", //任务状态
      applyTypeValue: "",
      applyTypeOptions: [
        {
          value: 1,
          label: "调查表审核"
        },
        //  {
        //   value: 2,
        //   label: '产品发布'
        // }, {
        //   value: 3,
        //   label: '申请入会'
        // },
        {
          value: 4,
          label: "资质补贴及荣誉审核"
        },
        {
          value: 5,
          label: "企业联系人审核"
        },
        {
          value: 6,
          label: "缴费凭证审核"
        },
        {
          value: 7,
          label: "文件管理审核"
        }
      ],
      startChangeTime: "",
      isRotate: false,
      taskParams: {
        applyStatus: "",
        startTimeStr: "",
        endTimeStr: "",
        companyName: "",
        applyType: "",
        sort: "desc",
        pageNumber: 1,
        pageSize: 5,
        taskStatus: "",
        approveStatus: ""
      },
      totalPage: 0,
      taskList: [],
      // 审批历史
      historyVisible: false,
      historyData: [],
      selectName: "", // 人物分配选中时的名字
      reasonData: {},
      quesNaireData: {},
      startTime: "", // 申请开始时间
      nowTime: "", // 当前时间
      threeTime: "", // 三天时间
      fiveTime: "", // 五天时间
      defferTime: "", // 当前时间与创建时间的时间差
      defferTime3: "", // 3天后时间与创建时间的时间差
      defferTime5: "", // 5天后时间与创建时间的时间差
      soonTimeOut: "", // 即将超时
      lastTime: "", // 超时时间
      timer: null,
      soonTimer: null,
      timeOutDay: "",
      soonTimeDay: "",
      soonTimeOutDay: "",
      soontime: [],
      outtime: [],
      outTimer: null,
      currentTime: new Date() // 获取当前时
    };
  },
  created() {
    this.findAllTask();
    this.init();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    init() {
      // console.log(sessionStorage.getItem("userName"), "1");
    },
    conditionChange() {
      this.taskParams.pageNumber = 1;
      this.findAllTask();
    },
    handleTabClick(tab) {
      this.activeName = tab.name;
      if (this.activeName == "1") {
        this.taskParams.applyStatus = "";
      } else if (this.activeName == "2") {
        this.taskParams.applyStatus = 8;
      } else if (this.activeName == "3") {
        this.taskParams.applyStatus = 7;
      }
      this.activeIndex = 0;
      this.taskParams.pageNumber = 1;
      this.findAllTask();
    },
    // 查询所有审批记录
    async findAllTask(val) {
      clearInterval(this.soonTimer);
      clearInterval(this.outTimer);
      const { data } = await getRecordList(this.taskParams);
      if (data.code != 0) return;
      this.taskList = JSON.parse(JSON.stringify(data.applyRecordList));
      this.totalPage = data.total;
      if (this.taskParams.applyStatus == "" || this.activeName == "2") {
        this.pendingTotal = data.applyCount;
        sessionStorage.setItem("pendingTotal", this.pendingTotal);
      }

      time(this.timer, this.taskList, this.startTime, this);
    },
    allTask() {
      if (this.activeName == "1") {
        this.taskParams.applyStatus = "";
      } else if (this.activeName == "2") {
        this.taskParams.applyStatus = 8;
        this.taskParams.approveStatus = "";
      }
      this.activeIndex = 0;
      this.taskParams.pageNumber = 1;
      this.findAllTask();
    },
    aboutToTimeOut() {
      if (this.activeName == "1") {
        this.taskParams.applyStatus = 2;
      } else if (this.activeName == "2") {
        // this.taskParams.taskStatus = 2
        // this.taskParams.applyStatus = 8
        this.taskParams.approveStatus = 1;
      }
      this.activeIndex = 1;
      this.taskParams.pageNumber = 1;
      this.findAllTask();
    },
    timeOut() {
      if (this.activeName == "1") {
        this.taskParams.applyStatus = 3;
      } else if (this.activeName == "2") {
        // this.taskParams.taskStatus = 2
        this.taskParams.approveStatus = 2;
      }
      this.activeIndex = 2;
      this.taskParams.pageNumber = 1;
      this.findAllTask();
    },
    taskCurrent(page) {
      this.taskParams.pageNumber = page;
      if (this.activeName == "1") {
        if (this.activeIndex == 0) {
          this.taskParams.applyStatus = "";
        } else if (this.activeIndex == 1) {
          this.taskParams.applyStatus = 2;
        } else if (this.activeIndex == 2) {
          this.taskParams.applyStatus = 3;
        }
      } else if (this.activeName == "2") {
        if (this.activeIndex == 0) {
          this.taskParams.applyStatus = 8;
        } else if (this.activeIndex == 1) {
          this.taskParams.applyStatus = 2;
          this.taskParams.approveStatus = 1;
        } else if (this.activeIndex == 2) {
          this.taskParams.applyStatus = 3;
          this.taskParams.approveStatus = 1;
        }
      }
      this.findAllTask();
    },
    // 发起日搜索事件
    dateChange(val) {
      if (val == null) {
        this.taskParams.startTimeStr = "";
        this.taskParams.endTimeStr = "";
      } else {
        this.taskParams.startTimeStr = this.$dayjs(val[0]).format(
          '"YYYY-MM-DD HH:mm:ss"'
        );
        this.taskParams.endTimeStr = this.$dayjs(val[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.findAllTask();
    },
    // 排序
    handleImg() {
      this.isRotate = !this.isRotate;
      if (this.isRotate) {
        this.taskParams.sort = "asc";
      } else {
        this.taskParams.sort = "desc";
      }
      this.findAllTask();
    },
    // 上一节点审批历史记录
    async lastNode(id) {
      this.historyVisible = true;
      const { data } = await findApproveHistory(id);
      if (data.code != 0) return;
      this.historyData = JSON.parse(JSON.stringify(data.approveHistoryList));
      this.historyData = this.historyData.filter(
        item => item.returnReason != null
      );
    },
    //关闭审批历史
    clearHistory() {
      this.historyData = [];
    },
    // 接受任务
    async receiveTask(row) {
      this.quesNaireData = row;
      this.quesNaireData.taskStatus = 2;
      // this.quesYear = JSON.parse(this.quesNaireData.param).year
      if (row.applyType == 1) {
        this.tabIndex = 1;
      } else if (row.applyType == 2) {
        this.tabIndex = 2;
      } else if (row.applyType == 3) {
        this.tabIndex = 3;
      } else if (row.applyType == 4) {
        this.tabIndex = 4;
      } else if (row.applyType == 5) {
        this.tabIndex = 5;
      } else if (row.applyType == 6) {
        this.tabIndex = 6;
      } else if (row.applyType == 7) {
        this.tabIndex = 7;
      }
      this.$children[0].$children[7].receiveParams.id = row.id;
      this.$children[0].$children[7].receiveParams.taskStatus = 2;
      const { data } = await taskManagement(
        this.$children[0].$children[7].receiveParams
      );
      if (data.code != 0) return;
      this.findAllTask();
      this.$parent.$parent.$parent.getApplyNums();

      // // 跳转详情页面
      // // setTimeout(() => {
      // this.quesNaireData = row
      // this.quesNaireData.taskStatus = 2
      // // this.quesYear = JSON.parse(this.quesNaireData.param).year
      // if (row.applyType == 1) {
      //   this.tabIndex = 1
      // } else if (row.applyType == 2) {
      //   this.tabIndex = 2
      // } else if (row.applyType == 3) {
      //   this.tabIndex = 3
      // } else if (row.applyType == 4) {
      //   this.tabIndex = 4
      // } else if (row.applyType == 5) {
      //   this.tabIndex = 5
      // } else if (row.applyType == 6) {
      //   this.tabIndex = 6
      // }
      // }, 100);
    },
    // 任务退回
    refuseTask(id) {
      this.$children[0].$children[7].titleName = "任务退回";
      this.$children[0].$children[7].refuseVisible = true;
      this.$children[0].$children[7].step = 1;
      this.$children[0].$children[7].receiveParams.id = id;
      this.$children[0].$children[7].receiveParams.taskStatus = 1;
    },
    // 驳回原因
    async reason(id) {
      const { data } = await failReason(id);
      if (data.code != 0) return;
      this.reasonData = data.applyRecord;
    },
    // 详情页面
    gToQuesNare(row) {
      this.quesNaireData = row;
      // this.quesYear = JSON.parse(this.quesNaireData.param).year
      if (row.applyType == 1) {
        this.tabIndex = 1;
      } else if (row.applyType == 2) {
        this.tabIndex = 2;
      } else if (row.applyType == 3) {
        this.tabIndex = 3;
      } else if (row.applyType == 4) {
        this.tabIndex = 4;
      } else if (row.applyType == 5) {
        this.tabIndex = 5;
      } else if (row.applyType == 6) {
        this.tabIndex = 6;
      } else if (row.applyType == 7) {
        this.tabIndex = 7;
      }
    }
  },
  components: {
    Questionnaire,
    HonorInfo,
    Contact,
    Payment,
    BackDialog,
    FileManagement
  }
};
